<h3>Soteam has been updated!</h3>
<p>To use new features please <a (click)="onRefresh()" class="link">reload the page</a>. You can find details on the <a (click)="openLink()" class="link">"What's new" section.</a></p>
